import { render, staticRenderFns } from "./BiddingList.vue?vue&type=template&id=1ff61b5c&scoped=true&"
import script from "./BiddingList.vue?vue&type=script&lang=js&"
export * from "./BiddingList.vue?vue&type=script&lang=js&"
import style0 from "./BiddingList.vue?vue&type=style&index=0&id=1ff61b5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff61b5c",
  null
  
)

export default component.exports